import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { sentimentValues, defaultSentimentPeriod } from '../../../../data/directory/topics/topicsSentimentAnalysis';
import { setSelectedActivePoint, setSelectedLocation } from '../../../../actions/locationsSentiment.actions';

import PeriodFilters from '../PeriodFilters';
import WorldSentiments from './WorldSentiments';
import SentimentWorldChart from '../../LocationsSentiment/SentimentWorldChart';
import Scrollable from '../../../Shared/Scrollable';

import Styles from './styles.module.scss';

const Locations = () => {
  const [activePeriod, setActivePeriod] = useState(defaultSentimentPeriod);
  const [activeListPeriod, setActiveListPeriod] = useState(defaultSentimentPeriod);

  const dispatch = useDispatch();
  const { activeLocationPoint, selectedLocationProps } = useSelector(({ locationsSentiment }) => ({
    activeLocationPoint: locationsSentiment.activeLocationPoint,
    selectedLocationProps: locationsSentiment.selectedLocation,
  }));

  const handlePeriodChange = (value) => {
    setActivePeriod(value);
    if (activeLocationPoint) {
      dispatch(setSelectedActivePoint(null));
    }
    if (selectedLocationProps) {
      dispatch(setSelectedLocation(null));
    }
  };

  const handleListPeriodChange = (value) => {
    setActiveListPeriod(value);
  };

  return (
    <div className={Styles.locations}>
      <div className={Styles['locations-header']}>
        <div className={Styles['locations-header-title']}>Locations</div>
        <PeriodFilters onFilterChange={handlePeriodChange} />
      </div>
      <div className={Styles['locations-desc']}>
        Location isn't everything, and neither is market psychology.
        But market sentiment for countries to cities bolsters investment due diligence,
        a critical tool for every investor or trader.
        {' '}
        <a href="/features/sentiment">
          Learn more.
        </a>
      </div>
      <div>
        <SentimentWorldChart
          isLocationsTab={false}
          isNewsSentiment
          selectedMainTimePeriod={activePeriod}
          hasBigScreenDesign
        />
      </div>
      <div className={Styles['locations-btn']}>
        <Link
          to="/directory/sentiment/locations"
          className={Styles.button}
        >
          Explore Location Sentiment
        </Link>
      </div>
      <div className={Styles['locations-box']}>
        <div className={Styles['locations-box-header']}>
          <div className={Styles['locations-box-header-title']}>How The World Feels Now</div>
          <PeriodFilters
            className={Styles['locations-box-header-filter']}
            onFilterChange={handleListPeriodChange}
          />
        </div>
        <Scrollable
          className={Styles['locations-box-slider']}
          wrapperClassName={Styles['locations-box-holder']}
          arrowClass={Styles['locations-box-holder-arrow']}
          isAllowFull
        >
          {sentimentValues.map(({
            id, title, value, icon,
          }) => (
            <WorldSentiments
              key={id}
              title={title}
              sentimentType={value}
              icon={icon}
              activePeriod={activeListPeriod}
            />
          ))}
        </Scrollable>
      </div>
    </div>
  );
};

export default Locations;
